import React, { useEffect, useState  } from 'react';
 import SeoHelmet from "../components/SeoHelmet";
 import StudioPageContact from "../components/StudioPageContact";
import ContactModal from "../components/ContactModal";
import CustomerSay from "../components/CustomerSay";

import slide1 from '../assets/img/design_studio.jpg';
import Icon1 from '../assets/img/icon1.png';
import Icon2 from '../assets/img/Shape.svg';




import User1 from '../assets/img/user_1.jpg';
import User2 from '../assets/img/user_2.jpg';
import User3 from '../assets/img/user_3.jpg';


import People1 from '../assets/img/client_1.jpg';
import People2 from '../assets/img/client_2.png';
import People3 from '../assets/img/client_3.png';
import People4 from '../assets/img/client_4.jpg';
import Twitter from '../assets/img/twitter-logo.svg';
import Linkedin from '../assets/img/linkedin-logo.svg';



import Pro2 from '../assets/img/arrow_right.svg';
import Pro4 from '../assets/img/arrow_right.svg';
import Pro6 from '../assets/img/arrow_right.svg';
import Pro8 from '../assets/img/arrow_down.svg';
import Pro10 from '../assets/img/back_arrow.svg';
import Pro12 from '../assets/img/back_arrow.svg';




import Studio from '../assets/img/the_studio.jpg';

import Form from '../assets/img/studio_form_bg.jpg';




import Con1 from '../assets/img/confort_1.svg';
import Con2 from '../assets/img/confort_2.svg';
import Con3 from '../assets/img/confort_3.svg';
import Con4 from '../assets/img/confort_4.svg';
import Con5 from '../assets/img/confort_5.svg';
import Con6 from '../assets/img/confort_two.svg';
import Con7 from '../assets/img/confort_7.svg';

const Aboutus = () => {


useEffect(() => {

    if (window.Swiper) {

 
      const custswiper = new window.Swiper(".customerslide", {
        loop: true,
        slidesPerView: 1,
       
        pagination: {
          el: ".swiper-paginationnn",
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
           slidesPerGroup: 3,

          },
          // You can add more breakpoints if needed
        },

      });

    }




  }, []);

  return (
    <>
     <SeoHelmet />
      <ContactModal />
       <section>
        <div className="swiper animeslide">
          <div className="swiper-wrapper">

            <div className="swiper-slide animeslide-slide slide1 design_banner" style={{ backgroundImage: `url(${slide1})` }}>
              <div className="container">
                <div className="row">
                  <div className="col-sm-12 banner_content design_bg">
                    <div className="content-slide design_content">
                         <h2>Design Studio</h2>  
                         <p>Where creativity meets functionality<br></br> to craft textiles that embody your<br></br> brand.</p>         
                    </div>
                  </div>
                </div>

              </div>
            </div>


          </div>
         
        </div>
      </section>
       <section className="ambience_and_harmony_section">
        <div className="container">
          <div className="row about_the_studio">
            <div className="col-sm-6">
              <div className="ambience_content">
                <div className="brands_content the_studio" >
                  <h2>About The Studio</h2>
                  <p>Our Design Studio is the heart of every project—<b>a space where ideas take shape and concepts become tangible designs.</b> From understanding your brand’s identity to experimenting with fabrics, colors, and prototypes, our team works closely with you to create uniforms, linens, and essentials that are<b> distinctive, functional, and aligned with your vision.</b> It’s where <b>innovation and craftsmanship meet,</b> ensuring every product we deliver feels uniquely yours.</p>
                  <div data-animate="bottom" className="animeslide-desc studio_btn">
                        <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><span>Let’s Get Started</span><img src={Icon1} alt="" /></a>
                      </div>
                </div>
              </div>
            </div>
            <div className="col-sm-1"></div>
            <div className="col-sm-5">
              <div className="ambience_imgs">                
                    <img src={Studio} alt="" className='studio' />
              </div>
            </div>
          </div>
        </div>
      </section>
        <section className="our_process_section design_process">
               <div className="container">
                 <div className="row">
                   <div className="brands_content process_content " >
                     <h2>Our Process - From Sketch to Stitch</h2>
                     <p>From understanding your brand to delivering the finished product, we perfect every step.</p>
                   </div>
                   <div className="process_content_img" >
                     <div className="process_content_img_1" >
                       <img src={Con1} alt="" className='logom heightimg' />
                       <h3>1. BRAND REQUIREMENT</h3>
                     </div>
                     <div className="process_content_img_1" >
                       <img src={Pro2} alt="" className='logomm' />
       
                     </div>
                     <div className="process_content_img_1" >
                       <img src={Con6} alt="" className='logom heightimg' />
                       <h3>2. PRODUCT DESIGN</h3>
       
                     </div>
                     <div className="process_content_img_1" >
                       <img src={Pro4} alt="" className='logomm' />
       
                     </div>
                     <div className="process_content_img_1" >
                       <img src={Con2} alt="" className='logom heightimg' />
                       <h3>3. SAMPLING AND PRODUCT DEV</h3>
                     </div>
                     <div className="process_content_img_1" >
                       <img src={Pro6} alt="" className='logomm' />
                       <h3></h3>
                     </div>
                     <div className="process_content_img_1" >
                       <img src={Con3} alt="" className='logom heightimg' />
                       <h3>4. FORECASTING</h3>
                     </div>
                     <div className="process_content_img_2" >
                       <h2>Share Your Vision. We’ll<br></br> Bring It to Life</h2>
                       <div data-animate="bottom" className="animeslide-des">
                         <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><span>Get In Touch</span></a>
                       </div>
                     </div>
                     <div className="process_content_img_1 " >
       
                     </div>
                     <div className="process_content_img_1" >
                       <img src={Con5} alt="" className='logom heightimg' />
                       <h3>7. DELIVERY</h3>
                     </div>
                     <div className="process_content_img_1" >
                       <img src={Pro12} alt="" className='logomm' />
                       <h3></h3>
                     </div>
                     <div className="process_content_img_1" >
                       <img src={Con4} alt="" className='logom heightimg' />
                       <h3>6. WAREHOUSING AND SHIPPING</h3>
                     </div>
       
                     <div className="process_content_img_1" >
                       <img src={Pro10} alt="" className='logomm' />
                     </div>
       
                     <div className="process_content_img_1" >
                       <img src={Con7} alt="" className='logom heightimg' />
                       <h3>5. MANUFACTURING</h3>
                     </div>
       
                     <div className="process_content_img_1" >
                       <img src={Pro8} alt="" className='process_img' />
       
                     </div>
                     <div className="process_content_img_2 mobile" >
                       <h2>Share Your Vision. We’ll<br></br> Bring It to Life</h2>
                       <div data-animate="bottom" className="animeslide-des">
                         <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><span>Get In Touch</span></a>
                       </div>
                     </div>
       
                   </div>
                 </div>
               </div>
             </section>
       <section className="get_in_touch_section" style={{ backgroundImage: `url(${Form})` }}>
        <div className="container">
          <div className="row get_in_touch">
             <div className="col-sm-12 inspiration">
              <div className="get_in_touch_right inspiration_form">
                <StudioPageContact />
              </div>
            </div>
            {/* <div className="col-sm-5 get_in_touch_left">
              <div className="get_in_touch_lefts">
                <div className="brands_content get_content" >
                  <h2>Get In Touch</h2>
                  <p>Every great idea begins with a chat. Let’s talk about your next project.</p>
                </div>
                <img src={Get2} alt="" className='get_in_touch' />
              </div>
            </div> */}
           
          </div>
        </div>
      </section>
       <section className="customer_say_section the_threads_section">
               <div className="container">
                 <div className="brands_content customer_say_title teampartt">
                   <h2>The People Behind the Threads</h2>
                   <p>
                     A passionate team turning ideas into finely crafted textiles,
                     every single day.
                   </p>
                 </div>
                 <div className="our_customer_say">
                   <div className="row">
                     <div className="col-sm-3"></div>
                     <div className="col-sm-3">
                       <div className="customer_say people">
                         <img src={People2} alt="" className="logom" />
                         <div className="people_title">
                           <div className="people_title_left">
                             <h3>Sunil Jain</h3>
                             <p>Director</p>
                           </div>
                           <div className="people_title_right">
                             {/* <img src={Twitter} alt="" className="logom" /> */}
                             <img src={Linkedin} alt="" className="logom" />
                           </div>
                         </div>
                        
                       </div>
                     </div>
                     <div className="col-sm-3">
                       <div className="customer_say people">
                         <img src={People3} alt="" className="logom" />
                         <div className="people_title">
                           <div className="people_title_left">
                             <h3>Anil Jain</h3>
                             <p>Director</p>
                           </div>
                           <div className="people_title_right">
                             {/* <img src={Twitter} alt="" className="logom" /> */}
                             <img src={Linkedin} alt="" className="logom" />
                           </div>
                         </div>
                        
                       </div>
                     </div>
                     <div className="col-sm-3"></div>
                   </div>
                 </div>
               </div>
             </section>
       <CustomerSay />
    </>
  );
}; 

export default Aboutus;
